var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whiteboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.854,
    height: 74.078,
    viewBox: "0 0 82.854 74.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_49_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_50---Interactive-Presentation",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_268_",
    d: "M78.712,8.533H4.143A4,4,0,0,0,0,12.365V66.007a4,4,0,0,0,4.143,3.832H16.571a2.664,2.664,0,0,0,2.762,2.554H58v7.663a2.664,2.664,0,0,0,2.762,2.554H78.021a5.047,5.047,0,0,0,3.409-1.271,4.173,4.173,0,0,0,1.424-3.11V12.365a4,4,0,0,0-4.143-3.832ZM19.333,69.839V67.284H58v2.554Zm60.76,8.391a1.727,1.727,0,0,1-.6,1.285,2.207,2.207,0,0,1-1.476.542A1.964,1.964,0,0,1,75.95,78.23V63.453a1.385,1.385,0,0,0-2.762,0V78.23a4.029,4.029,0,0,0,.439,1.826H60.76v-16.6a4,4,0,0,0-4.143-3.832H40.937a2.173,2.173,0,0,1-2.261-1.713,1.812,1.812,0,0,1,.523-1.487,2.15,2.15,0,0,1,1.537-.632h30.38c4.876-.071,8.893,3.524,8.976,8.034V78.23ZM59.379,45.572c0-4.232,3.71-7.663,8.285-7.663s8.285,3.431,8.285,7.663-3.71,7.663-8.285,7.663S59.384,49.8,59.379,45.572Zm15.008,8.09a9.781,9.781,0,0,0,3.8-11.231,10.965,10.965,0,0,0-10.155-7.09A11.1,11.1,0,0,0,57.391,41.8a9.711,9.711,0,0,0,2.99,11.438H41.427V48.126a1.385,1.385,0,0,0-2.762,0V53.68a4.373,4.373,0,0,0-2.737,4.484,4.881,4.881,0,0,0,5.008,4.012h15.68A1.332,1.332,0,0,1,58,63.453V64.73H19.333a2.664,2.664,0,0,0-2.762,2.554H4.143a1.332,1.332,0,0,1-1.381-1.277V12.365a1.332,1.332,0,0,1,1.381-1.277H78.712a1.332,1.332,0,0,1,1.381,1.277v44.65a11.939,11.939,0,0,0-5.706-3.353Z",
    transform: "translate(0 -8.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_267_",
    d: "M35.516,46.587a1.44,1.44,0,0,0,.976-.374l1.381-1.277a1.21,1.21,0,0,0-.017-1.79,1.462,1.462,0,0,0-1.936-.016L34.54,44.407a1.208,1.208,0,0,0-.3,1.392A1.386,1.386,0,0,0,35.516,46.587Z",
    transform: "translate(-28.611 -37.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_266_",
    d: "M44.117,42.952l-9.666,8.94a1.215,1.215,0,0,0-.377,1.242,1.333,1.333,0,0,0,.986.912A1.457,1.457,0,0,0,36.4,53.7l9.666-8.94a1.215,1.215,0,0,0,.377-1.242,1.333,1.333,0,0,0-.986-.912A1.456,1.456,0,0,0,44.117,42.952Z",
    transform: "translate(-28.522 -37.468)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.0d15b2246c55cf9c1ece73a3b987bd89.svg";
export { ForwardRef as ReactComponent };